module.exports = require("bull-arena");